import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconVimeo20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconVimeo20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M17.993 7.01q-.105 2.192-3.26 6.007Q11.46 16.998 9.204 17q-1.398 0-2.365-2.426l-1.291-4.447q-.72-2.424-1.542-2.426-.18 0-1.254.708L2 7.499q1.185-.976 2.333-1.95 1.582-1.282 2.37-1.35 1.867-.168 2.299 2.4.465 2.768.64 3.449.54 2.297 1.185 2.296.503 0 1.508-1.491 1.005-1.49 1.076-2.269.144-1.286-1.076-1.287a3.2 3.2 0 0 0-1.184.246q1.186-3.64 4.51-3.54 2.467.07 2.332 3.006"
            />
        </svg>
    );
}
export default memo(IconVimeo20);
